import { useState } from "react";
import { UserCheck, Loader2, Check } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";

/**
 * AssignToSellerButton — weist einen Cockpit-Hinweis mit Fahrzeugbezug per
 * 1-Klick dem zuständigen Verkäufer (dispo_salesperson) als Aufgabe zu. Die
 * Aufgabe erscheint im Firma-Bereich des Verkäufers.
 */
export default function AssignToSellerButton({ listingId, sellerName, title, area = "Disposition", ctaUrl, compact = true }) {
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);
    if (!listingId || !sellerName) return null;

    const assign = async (e) => {
        e?.stopPropagation();
        setBusy(true);
        try {
            const r = await api.post("/dealer/tasks/assign-to-seller", {
                listing_id: listingId, title, area, cta_url: ctaUrl || null,
            });
            setDone(true);
            toast.success(`An ${r.data.assignee_name} zugewiesen`);
        } catch (err) {
            toast.error(err.response?.data?.detail || "Zuweisen fehlgeschlagen");
        } finally {
            setBusy(false);
        }
    };

    if (done) {
        return (
            <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-emerald-700" data-testid={`assign-seller-done-${listingId}`}>
                <Check className="w-3 h-3" /> {sellerName}
            </span>
        );
    }
    return (
        <button
            type="button"
            onClick={assign}
            disabled={busy}
            className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-[#111827] border border-gray-300 rounded-sm px-2 py-1 bg-white hover:border-[#FFCC00] disabled:opacity-50 shrink-0"
            data-testid={`assign-seller-${listingId}`}
            title={`An ${sellerName} zuweisen`}
        >
            {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <UserCheck className="w-3 h-3" />}
            {compact ? sellerName : `An ${sellerName} zuweisen`}
        </button>
    );
}
